import { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext();

// Atlas now uses a single light theme (dark navy sidebar + light canvas)
// per the June 2026 redesign. The provider is kept so existing
// `useTheme()` consumers don't break, but the theme is always 'light'.
export function ThemeProvider({ children }) {
  useEffect(() => {
    window.document.documentElement.classList.remove('dark');
    localStorage.setItem('breeze-theme', 'light');
  }, []);

  return (
    <ThemeContext.Provider value={{ theme: 'light', toggleTheme: () => {} }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
